/**
 * Shared admin page header used by every admin module.
 */
export function PageHead({
  title,
  description,
  actions,
}: {
  title: string;
  description?: string;
  actions?: React.ReactNode;
}) {
  return (
    <div className="admin-page-head">
      <div className="admin-page-head-left">
        <div>
          <h2>{title}</h2>
          {description && <p>{description}</p>}
        </div>
      </div>
      {actions && <div className="admin-page-head-actions">{actions}</div>}
    </div>
  );
}
